module.exports = __webpack_public_path__ + "img/icon_img11.png";